import { openBlock as o, createElementBlock as a, normalizeClass as s, createElementVNode as r, toDisplayString as V, createCommentVNode as i } from "vue";
import { themeProp as n } from "../../composables/useTheme.js";
/* empty css          */
import H from "../../_virtual/_plugin-vue_export-helper.js";
const m = ["aria-label"], g = {
  key: 0,
  class: "ds-logo__label",
  "data-j-logo-label": ""
}, C = "DsLogo", d = /* @__PURE__ */ Object.assign({
  name: C
}, {
  __name: "logo",
  props: {
    ...n,
    ariaLabel: { type: String, required: !0 },
    label: { type: String, default: null }
  },
  setup(e) {
    return (l, t) => (o(), a("div", {
      class: s(`ds-logo ds-logo--${l.theme}`),
      "data-j-logo": ""
    }, [
      (o(), a("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "90",
        height: "30",
        viewBox: "0 0 90 30",
        "aria-label": e.ariaLabel,
        role: "img",
        class: "ds-logo__image",
        "data-j-logo-image": ""
      }, t[0] || (t[0] = [
        r("path", { d: "M27.7851 18.5234H26.0557C25.555 18.5234 25.1454 18.1138 25.1454 17.6131V6.622H21.7093C19.957 6.622 18.5234 8.05563 18.5234 9.80784V19.3198C18.5234 21.0721 19.957 22.5057 21.7093 22.5057H34.4071V0H27.7851V18.5234ZM12.6978 6.6221H0.22756V10.5816H8.35145C8.85209 10.5816 9.26169 10.9913 9.26169 11.4919V18.5235H7.53224C7.0316 18.5235 6.622 18.1139 6.622 17.6132V12.5614H3.18584C1.43363 12.5614 0 13.995 0 15.7473V19.2972C0 21.0494 1.43363 22.483 3.18584 22.483H15.8837V9.78518C15.8837 8.05573 14.4501 6.6221 12.6978 6.6221ZM44.6018 18.5235H46.3313V6.6221H52.9533V25.9419C52.9533 27.6942 51.5196 29.1278 49.7674 29.1278H37.2971V24.4856H46.3313V22.5058H40.2554C38.5032 22.5058 37.0696 21.0722 37.0696 19.3199V6.6221H43.6916V17.6132C43.6916 18.1139 44.1012 18.5235 44.6018 18.5235ZM68.2908 6.6221H55.593V19.32C55.593 21.0722 57.0266 22.5058 58.7788 22.5058H71.2491V18.5462H63.1252C62.6246 18.5462 62.215 18.1366 62.215 17.636V10.5816H63.9444C64.4451 10.5816 64.8547 10.9913 64.8547 11.4919V16.5437H68.2908C70.043 16.5437 71.4767 15.1101 71.4767 13.3579V9.80794C71.4767 8.05573 70.043 6.6221 68.2908 6.6221ZM74.1163 6.6221H86.8141C88.5891 6.6221 90 8.05573 90 9.78518V22.483H83.378V11.4919C83.378 10.9913 82.9684 10.5816 82.4677 10.5816H80.7383V22.5058H74.1163V6.6221Z" }, null, -1)
      ]), 8, m)),
      e.label ? (o(), a("span", g, V(e.label), 1)) : i("", !0)
    ], 2));
  }
}), u = /* @__PURE__ */ H(d, [["__scopeId", "data-v-b67c0967"]]);
export {
  u as default
};
